import React, { FC } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { useHistoryNew, getMemberCardStatus, formatCardNumber, modalLayer } from '@utils'
import CardEquityModal from '../CardEquityModal'
import QRCode from 'qrcode.react'
import './index.scss'

interface IProps {
  cardInfo: any;
}

const MycardDetailEnter: FC<IProps> = (props: IProps) => {
  const history = useHistoryNew()
  const { cardInfo } = props
  const statusInfo = getMemberCardStatus(cardInfo)
  const showCardEquity = (type: 'equity' | 'store' | 'integral' | 'recharge') => {
    modalLayer(CardEquityModal, { cardInfo, type }).then(() => { }, () => { })
  }
  const goRecord = (type: string) => {
    history.push(`/iRecord/flow/${type}/${cardInfo.cardNo}`)
  }
  return (
    <>
      <div className='card-detail-enter'>
        {
          statusInfo.status === 1 &&
            <div className='code-area'>
              <QRCode value={cardInfo.cardNo || ''} size={120} level='H' />
              <div className='cardno'>{formatCardNumber(cardInfo.cardNo || '')}</div>
            </div>
        }
        <div className='card-detail-enter-block'>
          {
            statusInfo.status === 1 && (cardInfo.card?.discountType || cardInfo.card?.mallDiscountType || cardInfo.card?.extra.cardRightsDes || cardInfo.card?.isSendCoupon) &&
              <div data-cypid='mmgClickMCardEquity' className='enter-item' onClick={(e: any) => { e.stopPropagation(); showCardEquity('equity') }}>
                <span>{i18n.t('mkt.member.memberDiscountBenefits')}</span>
                <i className='iconfont icon-chevron-right'></i>
              </div>
          }
          {
            cardInfo.card?.isIntegral &&
              <div data-cypid='mmgClickMCardIntegral' className='enter-item' onClick={(e: any) => { e.stopPropagation(); showCardEquity('integral') }}>
                <span>{i18n.t('cart.integralRule')}</span>
                <i className='iconfont icon-chevron-right'></i>
              </div>
          }
          <div data-cypid='mmgClickMCardRecordConsume' className='enter-item' onClick={(e: any) => { e.stopPropagation(); goRecord('consume') }}>
            <span>{i18n.t('mkt.member.consumeRecord')}</span>
            <i className='iconfont icon-chevron-right'></i>
          </div>
          <div data-cypid='mmgClickMCardRecordIntegral' className='enter-item' onClick={(e: any) => { e.stopPropagation(); goRecord('integral') }}>
            <span>{i18n.t('mkt.member.integralFlow')}</span>
            <i className='iconfont icon-chevron-right'></i>
          </div>
          {
            statusInfo.status === 1 &&
              <div data-cypid='mmgClickMCardStore' className='enter-item' onClick={(e: any) => { e.stopPropagation(); showCardEquity('store') }}>
                <span>{i18n.t('mkt.member.applyStore')}</span>
                <i className='iconfont icon-chevron-right'></i>
              </div>
          }
        </div>
      </div>
    </>
  )
}

export default observer(MycardDetailEnter)
